/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IncustControllersTermApiTermLoyaltyGoodsEditActiveRequest {
  /**
   * Active (1) or not (0)
   */
  active?: number;
}
